import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AudienceFilterTimeOperator } from '../../../audience/components/audience.model';
import TimeUtils from '../../utils/time-utils';

@Component({
  selector: 'app-timeframe-selector',
  templateUrl: './timeframe-selector.component.html',
  styleUrls: ['./timeframe-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TimeframeSelectorComponent {
  @Input() timeframeOperator: AudienceFilterTimeOperator;
  @Input() timeframeValueError: string;
  @Input() daysFC: UntypedFormControl;
  @Input() startDateFC: UntypedFormControl;
  @Input() endDateFC: UntypedFormControl;
  @Input() daysStartFC: UntypedFormControl;
  @Input() daysEndFC: UntypedFormControl;

  // Define these internally rather than as inputs
  public TimeframeOperators = [
    AudienceFilterTimeOperator.AnyTime,
    AudienceFilterTimeOperator.TimeWindow,
    AudienceFilterTimeOperator.SinceDate,
    AudienceFilterTimeOperator.BetweenDates,
    AudienceFilterTimeOperator.BetweenDaysAgo,
  ];
  public AudienceFilterTimeOperators = AudienceFilterTimeOperator;

  @Output() timeframeOperatorChanged = new EventEmitter<AudienceFilterTimeOperator>();

  onCloseSubMenuTimeFrame(event: Event, timeframeOperator: AudienceFilterTimeOperator): void {
    event.stopPropagation();
    this.timeframeOperator = timeframeOperator;
    this.timeframeOperatorChanged.emit(timeframeOperator);
    this.setDefaultValues();
  }

  onOpenSubMenu(event: Event): void {
    event.stopPropagation();
  }

  private setDefaultValues(): void {
    if (this.timeframeOperator === AudienceFilterTimeOperator.TimeWindow) {
      if (!this.daysFC.value) {
        this.daysFC.setValue(30);
      }
    } else if (this.timeframeOperator === AudienceFilterTimeOperator.SinceDate) {
      if (!this.startDateFC.value) {
        this.startDateFC.setValue(TimeUtils.getDateAddtoDate(-30, 'days'));
      }
    } else if (this.timeframeOperator === AudienceFilterTimeOperator.BetweenDates) {
      if (!this.startDateFC.value) {
        this.startDateFC.setValue(TimeUtils.getDateAddtoDate(-30, 'days'));
      }
      if (!this.endDateFC.value) {
        this.endDateFC.setValue(TimeUtils.getDateToDate());
      }
    }
  }
}
